import {AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {SafeSubscriberDirective} from '../../../../application/app-context/safe-subscriber.directive';
import {UserContextService} from '../../../../application/app-context/user-context/user-context.service';
import {AppLauncherApplication, ApplicationState} from '../../../../domain/app-launcher/model/app-launcher';
import {Account} from '../../../../domain/core/model/account';
import {AccountService} from '../../../../domain/core/service/account.service';
import {Role} from '../../../../domain/core/model/role';
import {LocalStorageKeyEnum} from '../../../../application/app-context/local-storage-key.enum';
import {ApplicationNamePipe} from '../../../pipes/application-name.pipe';
import {AmplitudeService} from '../../../../application/analytics/service/amplitude.service';
import {AnalyticsCategory} from '../../../../application/analytics/analytics-category';
import {AnalyticsEventType} from '../../../../application/analytics/analytics-event-type';
import {SalutationPipe} from '../../../pipes/salutation.pipe';

@Component({
             selector: 'app-menu',
             templateUrl: './home-menu.component.html',
             styleUrls: ['./home-menu.component.scss']
           })
export class HomeMenuComponent extends SafeSubscriberDirective implements OnInit, AfterViewInit {

  @Output() toggleMenuEvent: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('applicationsList') applicationsListElement: any;

  userName: string | undefined;
  isConsultant = false;
  isCollapse: boolean;
  applicationsListDisplayArrow = false;
  applicationsListMarginOffSet: number;
  applications: AppLauncherApplication[] | undefined;
  applicationsToDiscover: AppLauncherApplication[] | undefined;
  account: Account | undefined;

  appIconMap = new Map([
                         ['inviseo', 'opt-prospective'],
                         ['dotations', 'opt-dotation'],
                         ['alliance', 'opt-alliance'],
                         ['insito', 'opt-dette'],
                         ['funding_tender', 'opt-tender'],
                         ['bank_proposal_dashboard', 'opt-journaldesoffres'],
                         ['observatory', 'opt-observatoire'],
                         ['subsidies', 'opt-subsidies'],
                         ['treasury', 'opt-treasury'],
                         ['grants', 'opt-grants'],
                         ['apollo', 'opt-dette']
                       ]);

  constructor(public accountService: AccountService,
              private userContextService: UserContextService,
              private applicationNamePipe: ApplicationNamePipe,
              private salutationPipe: SalutationPipe,
              private amplitudeService: AmplitudeService) {
    super();
  }

  ngOnInit(): void {
    this.initFromUserContext();
    this.isCollapse = !this.isLeftMenuStatusOpen();
    this.applicationsListMarginOffSet = 60;
  }

  ngAfterViewInit(): void {
    if (!this.isLeftMenuStatusOpen()) {
      document.getElementById('panel-left').classList.remove('is-open');
    }

    // need for good positioning
    setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
    this.checkApplicationsListHeight();
  }

  onSwitchAccount(): void {
    this.initFromUserContext();
  }

  getIconClass(application: AppLauncherApplication): any {
    return this.appIconMap.get(application.appId);
  }

  getAccountLogoUrl(): string {
    return this.accountService.getAccountLogo(this.account);
  }

  isDisabled(application: AppLauncherApplication): boolean {
    return ApplicationState.IS_DISABLED === application.state;
  }

  isShoppable(application: AppLauncherApplication): boolean {
    return ApplicationState.IS_SHOPPABLE === application.state;
  }

  public toggleMenu(): void {
    setTimeout(() => {
      this.toggleMenuEvent.emit();
      this.toggleIsCollapse();
      if (this.isLeftMenuStatusOpen()) {
        localStorage.setItem(LocalStorageKeyEnum.LEFT_MENU_STATUS, 'close');
      } else {
        localStorage.setItem(LocalStorageKeyEnum.LEFT_MENU_STATUS, 'open');
      }

      // need for good positioning
      setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
      setTimeout(() => window.dispatchEvent(new Event('resize')), 10);
    }, 10);
  }

  public onClickRedirection(application: AppLauncherApplication): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('AppName', this.applicationNamePipe.transform(application.name));
    eventProperties.set('TypeLink', this.isShoppable(application) ? 'Pub' : 'Acces');
    this.amplitudeService.trackEventAction(AnalyticsCategory.leftMenu, AnalyticsEventType.appList, eventProperties);
  }

  public scrollApplicationsListToBottom(): void {
    const applicationsList = document.getElementById('applications-list');
    applicationsList.scrollTo({behavior: 'smooth', top: applicationsList.scrollHeight});
  }

  private isLeftMenuStatusOpen(): boolean {
    return localStorage.getItem(LocalStorageKeyEnum.LEFT_MENU_STATUS) == null
           || localStorage.getItem(LocalStorageKeyEnum.LEFT_MENU_STATUS) === 'open';
  }

  private initFromUserContext(): void {
    const userContext = this.userContextService.getUserContext();
    const user = userContext.user;
    this.userName = user.salutation && user.salutation !== 'UNDEFINED'
                    ? `${this.salutationPipe.transform(user.salutation)} ${user.lastname}`
                    : `${user.firstname} ${user.lastname}`;
    this.isConsultant = Role.isConsultant(user.role);
    this.applications = user.appLauncher?.applications?.filter(app => !this.isDisabled(app)).filter(a => !this.isShoppable(a));
    this.applicationsToDiscover = user.appLauncher?.applications?.filter(a => this.isShoppable(a));
    this.account = user.accounts.find(account => account.accountId === userContext.accountId);
  }

  private toggleIsCollapse(): void {
    this.isCollapse = !this.isCollapse;
  }

  @HostListener('window:resize')
  private checkApplicationsListHeight(): void {
    this.applicationsListDisplayArrow = this.applicationsListElement
                                        && this.applicationsListElement.nativeElement.clientHeight
                                        < this.applicationsListElement.nativeElement.scrollHeight;
  }
}
